import ServiceUnavailable from "@/components/ServiceUnavailable";
import { AuthenticationProvider } from "@/contexts/Authentication";
import Router from "@/routes";

const App = () => {
  if (process.env.REACT_APP_SERVICE_UNAVAILABLE === "true") {
    return <ServiceUnavailable />
  }

  return (
    <AuthenticationProvider>
      <Router />
    </AuthenticationProvider>
  )
};

export default App;
